module.exports = __webpack_public_path__ + "university-concordia.png?1208762217619b4ac9455df9352eaa2b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/university-concordia.png
// module id = 147
// module chunks = 0